var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEmptyRewards = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 184,
    viewBox: "0 0 252 184",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 252,
    height: 184,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Redeem Points",
    clipPath: "url(#clip0_316_13764)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 850,
    transform: "translate(-628 -379)",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 627517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 1330",
    filter: "url(#filter0_d_316_13764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-356 -239C-356 -243.418 -352.418 -247 -348 -247H601C605.418 -247 609 -243.418 609 -239V416C609 420.418 605.418 424 601 424H-348C-352.418 424 -356 420.418 -356 416V-239Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 626723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 626573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3959"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 153",
    d: "M26.0241 14.8681C-31.1238 58.5896 19.0207 119.033 51.2364 143.79C96.4368 178.525 200.962 211.771 244.42 143.79C292.685 68.2884 97.4591 -39.7836 26.0241 14.8681Z",
    fill: "#F4F5F7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 626571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 626570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0361 60.6967L91.8046 38.2965C93.195 37.5508 94.8429 37.4539 96.3112 38.0313L217.188 85.573C219.95 86.6593 221.308 89.7789 220.222 92.5408L194.259 158.553C193.173 161.315 190.053 162.673 187.291 161.587L66.361 114.024C64.9235 113.459 63.7989 112.302 63.2739 110.85L47.5219 67.2588C46.6156 64.7506 47.6859 61.9572 50.0361 60.6967ZM61.6506 77.927C64.9585 79.228 68.6948 77.6012 69.9958 74.2933C71.2968 70.9854 69.6699 67.2492 66.362 65.9482C63.0541 64.6471 59.3179 66.274 58.0169 69.5819C56.7159 72.8898 58.3428 76.626 61.6506 77.927Z",
    fill: "#B7CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1080",
    d: "M211.087 92.9883L187.979 152.638",
    stroke: "#AAC3FF",
    strokeWidth: 1.07476,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1081",
    d: "M98.2367 46.2341L75.1293 109.645",
    stroke: "#AAC3FF",
    strokeWidth: 1.07476,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M164.873 55.3733L159.235 53.5509C157.376 48.4211 165.657 46.5717 163.798 41.4014L169.435 43.2238C171.295 48.3941 163.013 50.2435 164.873 55.3733Z",
    fill: "#FCDF98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M83.8847 27.7987L81.5349 31.7414C77.0547 32.3727 76.7899 25.914 72.2899 26.5245L74.6272 22.5856C79.1272 21.975 79.392 28.4337 83.8847 27.7987Z",
    fill: "#84C8B1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M58.8257 134.693L57.3532 129.788C60.092 125.356 65.4863 129.735 68.2562 125.3L69.7348 130.191C66.965 134.626 61.5707 130.247 58.8257 134.693Z",
    fill: "#F4AE72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M223.561 136.798L223.125 129.741C228.415 125.153 234.374 133.426 239.664 128.838L240.045 135.978C234.794 140.471 228.851 132.209 223.561 136.798Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 375",
    d: "M63.1745 71.0455C63.9231 71.137 64.4592 71.8189 64.3304 72.562C63.3335 78.3144 60.5159 83.6095 56.2748 87.6563C51.7036 92.0181 45.7614 94.6599 39.4607 95.1316C33.1601 95.6033 26.8908 93.8758 21.721 90.2434C16.5513 86.6109 12.801 81.2983 11.1091 75.2108C9.41727 69.1232 9.88853 62.6374 12.4426 56.8583C14.9967 51.0793 19.4755 46.3646 25.1161 43.5176C30.7566 40.6706 37.2098 39.8675 43.3761 41.2451C49.0971 42.5232 54.2429 45.6051 58.065 50.0182C58.5587 50.5882 58.4514 51.449 57.8573 51.9136V51.9136C57.2633 52.3783 56.4079 52.2705 55.911 51.7032C52.4804 47.7864 47.885 45.0507 42.7806 43.9103C37.231 42.6705 31.4231 43.3934 26.3466 45.9556C21.2702 48.5179 17.2392 52.7611 14.9405 57.9623C12.6418 63.1634 12.2177 69.0007 13.7404 74.4795C15.2631 79.9583 18.6384 84.7396 23.2911 88.0088C27.9439 91.278 33.5862 92.8328 39.2568 92.4082C44.9274 91.9837 50.2754 89.6061 54.3895 85.6805C58.1734 82.0699 60.6983 77.3553 61.6159 72.2301C61.7488 71.4877 62.4259 70.954 63.1745 71.0455V71.0455Z",
    fill: "#F7D443"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3959_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik  Gift  inject 145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M116.069 81.7325L104.901 112.174L160.848 134.662L172.015 104.22L116.069 81.7325Z",
    fill: "#F2AE43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.7,
    d: "M129.99 86.7266L118.459 118.735L128.392 122.808L139.923 90.7999L129.99 86.7266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.1,
    d: "M152.808 95.2186L141.445 126.786L160.65 134.66L172.013 103.093L152.808 95.2186Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M116.994 76.6348L115.221 80.9548L173.149 104.099L174.922 99.7792L116.994 76.6348Z",
    fill: "#E1A038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.5,
    d: "M132.052 82.515L130.263 87.1045L139.774 91.1069L141.563 86.5174L132.052 82.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.1,
    d: "M154.563 91.2873L152.783 95.7427L173.123 104.097L174.902 99.642L154.563 91.2873Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M158.852 86.8628C159.358 85.5723 159.286 84.0987 158.652 82.7659C158.018 81.4331 156.873 80.3503 155.47 79.7555V79.7555L163.219 83.019C163.916 83.3124 164.557 83.7292 165.105 84.2455C165.653 84.7619 166.098 85.3677 166.415 86.0284C166.731 86.6891 166.912 87.3917 166.949 88.0962C166.985 88.8007 166.875 89.4932 166.626 90.1341C166.376 90.7751 165.992 91.352 165.495 91.8319C164.998 92.3119 164.397 92.6854 163.728 92.9311C163.059 93.1769 162.334 93.2902 161.595 93.2644C160.856 93.2386 160.117 93.0744 159.42 92.781L154.114 90.5468L151.698 89.5177C153.099 90.0971 154.637 90.1432 155.978 89.6459C157.318 89.1486 158.351 88.1482 158.852 86.8628V86.8628Z",
    fill: "#DA9D3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M155.569 79.9926L163.307 83.2442C162.611 82.9516 161.873 82.7878 161.135 82.7621C160.396 82.7364 159.672 82.8492 159.004 83.0943C158.336 83.3393 157.737 83.7116 157.24 84.19C156.744 84.6684 156.36 85.2435 156.111 85.8825V85.8825L154.214 90.7468L146.487 87.457L148.384 82.5927C148.893 81.3109 149.935 80.3175 151.282 79.8302C152.629 79.3428 154.17 79.4012 155.569 79.9926V79.9926Z",
    fill: "#F2AE43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M147.407 76.8319L139.651 73.5129C141.06 74.1099 142.211 75.1979 142.851 76.5384C143.491 77.8788 143.568 79.3622 143.066 80.6632L141.162 85.5678L148.918 88.8868L150.822 83.9822C151.072 83.3382 151.182 82.6423 151.146 81.9343C151.11 81.2263 150.928 80.5202 150.611 79.8562C150.294 79.1921 149.848 78.5833 149.298 78.0643C148.748 77.5454 148.106 77.1266 147.407 76.8319V76.8319Z",
    fill: "#DA9D3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M140.315 79.7236C140.82 78.4303 141.862 77.4254 143.213 76.9293C144.564 76.4331 146.112 76.4862 147.52 77.0769L139.781 73.7753C138.374 73.1828 136.825 73.1288 135.473 73.6251C134.122 74.1215 133.08 75.1275 132.576 76.422C132.072 77.7164 132.148 79.1932 132.787 80.5274C133.426 81.8617 134.575 82.9441 135.982 83.5366L141.288 85.7706L143.706 86.7919C142.314 86.1962 141.178 85.1208 140.543 83.7982C139.909 82.4756 139.827 81.0119 140.315 79.7236Z",
    fill: "#F2AE43"
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_316_13764",
    x: -364,
    y: -255,
    width: 981,
    height: 687,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.223437 0 0 0 0 0.265031 0 0 0 0 0.4125 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_316_13764"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_316_13764",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_13764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 850,
    fill: "white",
    transform: "translate(-628 -379)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptyRewards, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/empty-rewards.9f9576a0.svg";
export { ForwardRef as ReactComponent };